import Model from '../Model';
import DistributionSitesModel from './DistributionSitesModel';

export default class BundleDeletionModel extends Model {

	constructor(data) {
		super(data);
		this.sites = new DistributionSitesModel(data.sites);
		this.on_success = data.on_success;
	}

	build(dryRun) {
		let sitesModel = this.sites.build(dryRun);
		sitesModel.on_success = this.on_success;
		if(!sitesModel.distribution_rules || !sitesModel.distribution_rules.length) {
			delete sitesModel.distribution_rules;
		}
		return sitesModel;
	}
}



// WEBPACK FOOTER //
// ./modules/distribution/core/models/distribution/BundleDeletionModel.js